<template>
  <div class="login-log-page" v-loading="loading">
    <div class="con-body">
      <el-table :data="tableData" style="width: 100%">
        
        <el-table-column prop="username" :label="$t('manage.user_account')"></el-table-column>
        <el-table-column prop="ip" :label="$t('manage.login_ip')"> </el-table-column>
        <el-table-column prop="created_at" :label="$t('manage.login_date')"></el-table-column>
        <el-table-column prop="edit" :label="$t('control.operate')" width="200">
          <template slot-scope="scope">
            <div class="edit-button">
              <i
                class="el-icon-delete pointer"
                @click="delItem(scope.row.id)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import loginLogApi from "@/api/system/loginLog";
export default {
  data() {

    return {
      loading: false,
      dialogVisible: false,
      tableData: [],
      pageInfo: {
        sortBy: 'id',
        descending: 'desc',
        filter: '',
        page: 1,
        pageSize: 20
      },
      cnt_all: 0
    };
  },
  methods: {
    getTableData(pageIndex) {
      // 获取列表
      this.pageInfo.filter = ''
      this.loading = true;
      this.pageInfo.page = pageIndex;
      let pageFilter = this.pageInfo
      const filter = pageFilter.filter
      if(filter){
        pageFilter.filter = JSON.stringify(filter)
      }
      loginLogApi.getLoginLog(pageFilter).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },

    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    delItem(id) {
      this.$confirm(this.$t('control.tip_del_data_title'), this.$t('control.tip'), {
        confirmButtonText: this.$t('control.confirm'),
        cancelButtonText: this.$t('control.cancel'),
        type: "warning",
      })
        .then(() => {
          let ids = []
              ids[0] = id
          loginLogApi.LoginLogDel({
            ids: ids
          }).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.del_success'));
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('control.cancel_del'),
          });
        });
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  }
};
</script>
<style lang='less'>
.login-log-page{
  width: 100%;
}

</style>